import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { GenericAbortSignal } from "axios";
import { ManagedRoleUserGroupsAssignedQueryResponse, ManagedRoleUserGroupsAssignedQueryResponsePaginatedList } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { ListChildComponentProps } from "react-window";
import { GenericListDrawer, GenericListFilter, GenericListItemsType } from "views/common/GenericListDrawer";

////////////////////////////////////////////////////////////////////////////////

type ItemData = GenericListItemsType<ManagedRoleUserGroupsAssignedQueryResponse>;

/////////////////////////////////////////////////////////////////////////////////

interface IPros {
    userId: string;
    title?: string;
    subtitle?: string;
    onClose: () => void;
}

export const UserGroupsAssignedDrawer: React.FC<IPros> = (props) => {

    const api = useCoreApi();
    const { t } = useTranslation();

    const { title, subtitle, userId, onClose } = props;

    ////////////////////////////////////////////////////////////////////////////////    

    ///
    const handleGetData = (genericFilter: GenericListFilter, signal: GenericAbortSignal | undefined): Promise<ManagedRoleUserGroupsAssignedQueryResponsePaginatedList> => {
        return new Promise((resolve, reject) => {
            api.v1.securityRoleManagement.getUserGroupsAssigned({
                ...genericFilter,
                userId
            }, {signal } )
            .then((response) => resolve(response.data))
            .catch(reject);
        });
    };

    /**
     * Renderiza uma linha da Lista.
     * @param props
     */
    function renderRow(props: ListChildComponentProps<ItemData>) {
        const { index, style } = props;
        const { items } = props.data;

        const item = items[index];
        if (item == undefined) return <></>
        return (
            <div key={index} style={style}>
                <ListItem disablePadding disableGutters>
                    <ListItemAvatar sx={{ minWidth: 36 }}  >
                        <Avatar
                            src={item.thumbnailUrl}
                            sx={{ width: 32, height: 32 }} />
                    </ListItemAvatar >
                    <ListItemText primary={item.name} primaryTypographyProps={{ variant: "h6" }} />
                </ListItem>
            </div>
        );
    }

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <GenericListDrawer
            title={title || t("Role.UserGroupsAssignedDrawer.Title")}
            subtitle={subtitle}
            itemHeight={40}
            onClose={() => onClose()}
            onGetData={handleGetData}
            emptyDataMessage={t("Role.UserGroupsAssignedDrawer.ListEmptyMessage")}
            emptyFilterMessage={t("Role.UserGroupsAssignedDrawer.NoRecordsFoundMessage")}
            renderRow={renderRow}
        />
    );
};
